export default {
    performer: 'Performer',
    title: 'Naziv rasporeda',
    date: 'Datum',
    offers: 'Usluge',
}
